import type { VideoFrame } from '../types';

/** LRU cache for effect intermediate frames (preview performance). */
export class FrameCache {
  private readonly maxEntries: number;
  private readonly map = new Map<string, VideoFrame>();

  constructor(maxEntries = 32) {
    this.maxEntries = maxEntries;
  }

  key(effectId: string, frameIndex: number, pass: string): string {
    return `${effectId}:${frameIndex}:${pass}`;
  }

  get(effectId: string, frameIndex: number, pass: string): VideoFrame | undefined {
    const k = this.key(effectId, frameIndex, pass);
    const hit = this.map.get(k);
    if (hit) {
      this.map.delete(k);
      this.map.set(k, hit);
    }
    return hit;
  }

  set(effectId: string, frameIndex: number, pass: string, frame: VideoFrame): void {
    const k = this.key(effectId, frameIndex, pass);
    if (this.map.has(k)) this.map.delete(k);
    this.map.set(k, frame);
    while (this.map.size > this.maxEntries) {
      const oldest = this.map.keys().next().value;
      if (oldest) this.map.delete(oldest);
    }
  }

  clear(): void {
    this.map.clear();
  }
}
